import React from 'react'
import Layout from '../../components/common/layout'
import MarineServices from '../../components/services/marine-refrigeration'
import SEO from '../../components/common/seo'

const ServicesPage = () => (
  <Layout>
    <SEO title="San Diego Refrigeration &amp; A/C Repair" />
    <MarineServices />
  </Layout>
)

export default ServicesPage
